// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Popup-module_getOutAnimation__v2k7o {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(90vh);
    }
}

.Popup-module_overlay__Sgrrs {
    align-items: center;
    background: rgba(0, 0, 0, 0.48);
    bottom: 0;
    display: block;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
}

.Popup-module_popupOuter__FTlSN {
    align-items: flex-end;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 0 16px;
}

.Popup-module_popupBox__eTndB {
    animation-duration: 0.6s;
    animation-delay: 0.1s;
    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
    animation-iteration-count: 1;
    overflow: hidden;
    bottom: 24px;
    max-width: 568px;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.Popup-module_popupBoxAnimated__NaUYm {
    animation-name: Popup-module_getOutAnimation__v2k7o;
}

@media screen and (min-width: 708px) {
    .Popup-module_popupOuter__FTlSN {
        align-items: center;
    }

    .Popup-module_popupBox__eTndB {
        bottom: auto;
        border-radius: 16px;
        max-height: calc(100vh - 96px);
    }
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,iEAAiE;IACjE,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mDAA+B;AACnC;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":["@keyframes getOutAnimation {\n    0% {\n        transform: translateY(0);\n    }\n    100% {\n        transform: translateY(90vh);\n    }\n}\n\n.overlay {\n    align-items: center;\n    background: rgba(0, 0, 0, 0.48);\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 10000;\n}\n\n.popupOuter {\n    align-items: flex-end;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    padding: 0 16px;\n}\n\n.popupBox {\n    animation-duration: 0.6s;\n    animation-delay: 0.1s;\n    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n    animation-iteration-count: 1;\n    overflow: hidden;\n    bottom: 24px;\n    max-width: 568px;\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.popupBoxAnimated {\n    animation-name: getOutAnimation;\n}\n\n@media screen and (min-width: 708px) {\n    .popupOuter {\n        align-items: center;\n    }\n\n    .popupBox {\n        bottom: auto;\n        border-radius: 16px;\n        max-height: calc(100vh - 96px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Popup-module_overlay__Sgrrs`,
	"popupOuter": `Popup-module_popupOuter__FTlSN`,
	"popupBox": `Popup-module_popupBox__eTndB`,
	"popupBoxAnimated": `Popup-module_popupBoxAnimated__NaUYm`,
	"getOutAnimation": `Popup-module_getOutAnimation__v2k7o`
};
export default ___CSS_LOADER_EXPORT___;
